import * as React from "react"
import { Dashboard } from "../components/dashboard"
import { Layout } from "../components/layout"

export default function IndexPage() {
  return (
    <Layout>
      <Dashboard />
    </Layout>
  )
}
